import { FileType } from "frontend-lib/SizeChecker";

const allowedImageMIMETypes = ["image/png", "image/jpeg"];
const allowedVideoMIMETypes = ["video/mp4"];
const allowedAudioMIMETypes = ["audio/mpeg", "audio/ogg", "audio/aac"];
const allowedDocMIMETypes = ["application/pdf"];
const allAllowed = [
    ...allowedImageMIMETypes,
    ...allowedVideoMIMETypes,
    ...allowedAudioMIMETypes,
    ...allowedDocMIMETypes,
];
const maxSizeMb = 50 * 1000 * 1000;

const fileIsInAllowedTypes = (fileType: string): boolean => {
    return allAllowed.includes(fileType);
};

const fileExceedsLimit = (size: number): boolean => {
    return size >= maxSizeMb;
};

const getFileType = (fileType: string): FileType => {
    if (allowedImageMIMETypes.includes(fileType)) {
        return FileType.IMAGE;
    } else if (allowedVideoMIMETypes.includes(fileType)) {
        return FileType.VIDEO;
    } else if (allowedAudioMIMETypes.includes(fileType)) {
        return FileType.AUDIO;
    } else if (allowedDocMIMETypes.includes(fileType)) {
        return FileType.DOCUMENT;
    }
    return FileType.DOCUMENT;
};

export {
    fileIsInAllowedTypes,
    fileExceedsLimit,
    getFileType,
    allowedImageMIMETypes,
    allowedVideoMIMETypes,
    allowedAudioMIMETypes,
    allowedDocMIMETypes,
};
